import script from "./CampaignCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignCreateForm.vue?vue&type=style&index=0&id=9ab89334&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ab89334"]])

export default __exports__